import type { BetSlipResponse } from '@mobi/betslip/types'

export function getMultiBetResponse<T extends BetSlipResponse>(responses: T[]): T | undefined {
  return responses?.find?.(res => !!res.legs && res.legs.length > 1)
}
